import { ComponentProps, forwardRef, memo, SyntheticEvent, useCallback } from 'react'
import { Button as ButtonBase, IButtonProps as IButtonBaseProps } from '@cargomart/ui'
import { Link as RouterLink, useNavigate } from '@tanstack/react-router'
import cn from 'classnames'

export interface IButtonProps extends IButtonBaseProps {
  href?: string
  state?: ComponentProps<typeof RouterLink>['state']
  target?: string
  testId?: string
  to?: ComponentProps<typeof RouterLink>['to']
  wide?: boolean
}

export const Button = memo(
  forwardRef<HTMLButtonElement, IButtonProps>(function Button(
    { to, children, href, target = '_self', onClick, state, className, wide, variant = 'outline', testId, ...rest },
    ref
  ) {
    const navigate = useNavigate()

    const handleClick = useCallback(
      (e: SyntheticEvent<HTMLButtonElement, Event>) => {
        if (href) {
          window.open(href, target)
        }
        if (to) {
          navigate({ to, state })
        }

        onClick && onClick(e)
      },
      [href, to, onClick, target, navigate, state]
    )

    return (
      <ButtonBase
        ref={ref}
        className={cn(className, { 'w-full': wide })}
        data-test-id={testId}
        onClick={handleClick}
        variant={variant}
        {...rest}
      >
        {children}
      </ButtonBase>
    )
  })
)
